import { render, staticRenderFns } from "./AlertRulesView.vue?vue&type=template&id=9a9c5af0&scoped=true&lang=pug&"
import script from "./AlertRulesView.vue?vue&type=script&lang=ts&"
export * from "./AlertRulesView.vue?vue&type=script&lang=ts&"
import style0 from "./AlertRulesView.vue?vue&type=style&index=0&id=9a9c5af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9c5af0",
  null
  
)

export default component.exports